module.exports = __webpack_public_path__ + "img/hoel_politikk_og_psykologi1.bbb3719d.jpg";